import tippy from 'tippy.js';

class AccountTabs {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.tippyElements = element.querySelectorAll('.account-tabs__tab.show-tooltip');
    this.tippyInstances = [];

    if (this.tippyElements) {
      setTimeout(() => {
        this.init();
      }, 1);
    }
  }

  init() {
    document.body.classList.add('show-tooltips');
    this.tippyElements.forEach((tippyElement) => {
      this.tippyInstances.push(tippy(tippyElement, {
        content: tippyElement.dataset.intro ?? 'N/A',
        showOnCreate: true,
        zIndex: 999,
        placement: tippyElement.dataset.position ?? 'top',
        interactive: false,
        trigger: 'manual',
        theme: 'walkthrough',
        arrow: false,
      }));
    });

    setTimeout(() => {
      window.addEventListener('scroll', this.closeTippies.bind(this), { once: true });
    }, 1000);
    document.body.addEventListener('click', this.closeTippies.bind(this), { once: true });
  }

  closeTippies() {
    this.tippyInstances.forEach((instance) => {
      instance.hide();
      document.body.classList.remove('show-tooltips');
    });
  }
}

export default AccountTabs;
